import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import NextBestActionContext from '~/context/home/NextBestActionContext';
import feedItemMapper from './feedItemMapper';
import LoadingCard from './LoadingCard';

export default function StatusCard() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { data } = useContext(NextBestActionContext);

  if (!data) return <LoadingCard />;

  const feedItems = data?.feedItems || [];

  if (data?.isError || feedItems.length === 0) {
    trackEvent('Order Status Card Load Failed', data?.errorEventPayload);

    return null;
  }

  return <>{feedItems.map(feedItemMapper)}</>;
}
